import * as React from "react";
import { AuthConsumer } from "./AuthProvider";
import { Button } from "antd";

export default () => (
  <AuthConsumer>
    {auth => (
      <Button type="primary" onClick={() => auth.logout()}>
        Logout
      </Button>
    )}
  </AuthConsumer>
);



// WEBPACK FOOTER //
// ./src/components/AuthProvider/LogoutButton.tsx